import { streamRowV2Main } from '@synoptic/ui-kit/stream-row-v2/stream-row-v2.css.js';
import {
  StreamRowV2,
  StreamRowV2Copy,
  StreamRowV2Meta,
} from '@synoptic/ui-kit/stream-row-v2/stream-row-v2.js';
import { clsx } from 'clsx';
import { useNavigate } from 'react-router';
import { StreamCardFragmentFragment } from '@/__generated__/graphql.ts';
import { getUserAvatarSrc } from '@/components/s3/user/get-user-avatar-src.ts';
import { streamCardPriceV2 } from '@/components/stream-card-v2/stream-card-price-v2.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { formatNumber } from '@/utils/format-number.ts';
import { streamRowLinkV2 } from './stream-row-link-v2.css.ts';

export const StreamRowLinkV2 = ({
  stream,
}: {
  stream: StreamCardFragmentFragment;
}) => {
  const navigate = useNavigate();
  const streamHref = paths.makeStream(stream.id);
  const authorHref = paths.makeUser(stream.author.username);

  return (
    <StreamRowV2>
      <Link
        className={clsx(streamRowLinkV2, streamRowV2Main)}
        to={streamHref}
        data-testid="stream-row-link-v2"
      >
        <StreamRowV2Copy title={stream.name} description={stream.description} />
      </Link>
      <StreamRowV2Meta
        featured={stream.isFeatured}
        handle={stream.author.username}
        avatarSrc={getUserAvatarSrc(
          stream.author.id,
          stream.author.avatar?.key,
          'v2s',
        )}
        followers={formatNumber(stream.followersCount)}
        price={streamCardPriceV2(stream)}
        renderHandle={
          <Link to={authorHref} data-testid="stream-row-author-v2" />
        }
        onView={() => {
          void navigate(streamHref);
        }}
      />
    </StreamRowV2>
  );
};
